<i18n
  src="@/locales/views/packing_house/production/packing_by_pallet/show_process.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('list_processes')"
  >
  </go-back-link>

  <bread-crumbs :labels="[module_name, packing_house_process?.name]" />

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :packing_house_id="packing_house_id"
      :packing_house_process_id="packing_house_process_id"
    >
    </router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/packing_by_pallet/show_process.js";

export default {
  name: "PHProductionPackingByPalletShowProcess",
  components: {},
  data() {
    return {
      load_data_general: false,
      option_tabs: [],
      packing_house_process: {},
    };
  },
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fillOptions();
        this.fetchPackingHouseProcess();
      })
    );
  },
  methods: {
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-container-storage",
          route: { name: this.routeName("show_process_containers") },
        },
        {
          name: this.$t("labels.package_groups_from_stock_title"),
          icon: "fa-solid fa-pallet-box",
          route: { name: this.routeName("show_process_package_groups_from_stock") },
        },
      ];
    },
    fetchPackingHouseProcess: async function () {
      const response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );

      this.packing_house_process = response.data;
      this.load_data_general = true;
    },
  },
};
</script>
